import React, { Component } from 'react'
import { MemberLinkBtn  } from '../styles/Elements';
import '../css/BisharatMain.css';
import MemberDataService from '../services/MemberDataService';
import AuthService from "../services/AuthService";
import Login from '../pages/Login';
import translate from '../languages/translate';
import {
    MdDelete, MdBuild, MdZoomIn, MdChildCare, MdGroup, MdPerson, MdSearch
} from "react-icons/md";


export default class FamilyMembers extends Component {
    state = {
        members: [],
        selectedMember: {},
        selectedMemberHasChildren: false,
        selectedMemberHasPartner: false,
        showMemberClicked: false,
        search: ''
    }
  
    componentDidMount() {
    
        this.refreshMembers();
        this.setState({ selectedMember: '' });
    }

    refreshMembers = () => {
        const loggedInUser = AuthService.getCurrentUser();
        const whatRole = AuthService.getUserRole();
        if( !loggedInUser || (whatRole === ('USER')) ) {} else {
        MemberDataService.getAllMembers()
            .then(res => {
                const members = res.data;
                this.setState({ members });
            })
    }}

 
      
      onchangeFind = (event) => {
        this.setState({ search: event.target.value })
      }
      
      filterFunction = (people) => {
        return people.name.indexOf(this.state.search) > -1
      }
   



    deleteMemberClicked(id) {
        if (id === undefined) {
            alert("Please Select Member !");
        }
        MemberDataService.deleteMember(id)
            .then((response) => {
                this.refreshMembers();
                window.location.reload();
            })
            .catch((err) => {
            });
    }

    gotoMemberEdit(id) {
        if (id === undefined) {
            alert("Please Select Member !");
        } else {
            window.location.href = `/family-members/${id}/edit`;
        }


    }

    showMember(member) {
        this.setState({ selectedMember: member })
        this.setState({ showMemberClicked: true })
        //check if member have partner/wife
        if(member.partnerId === null) {
            this.setState({selectedMemberHasPartner : false})
        } else {
            this.setState({selectedMemberHasPartner : true})
        }
    //check if member have children
        if(member.children.length > 0) {
            this.setState({selectedMemberHasChildren : true})
        } else {
            this.setState({selectedMemberHasChildren : false}) 
        }
    }

    gotoMemberProfile(id) {
        if (id === undefined) {
            alert("Please Select Member !");
        } else {
            window.open(`/family-members/${id}`, '_blank');
        }

    }


    gotoUpalodProfilePicture(id) {
        if (id === undefined) {
            alert("Please Select Member !");
        } else {
            window.location.href = `/family-members/profile/${id}`;
        }

    }

    // gotoPartnerProfile(id) {
    //     if (id === undefined) {
    //         alert("Please Select Member !");
    //     } else {
    //         window.location.href = `/family-members/partner/${id}`;
    //     }
    // }


    gotoChildrenList(id) {
        if (id === undefined) {
            alert("Please Select Member !");
        } else {
            window.location.href = `/family-members/${id}/children`;
        }
    }

    goToCreateChild(id) {
        if (id === undefined) {
            alert("Please Select Member !");
        } else {
            window.location.href = `/family-members/${id}/childcreate`;
        }
    }


    render() {
        const loggedInUser = AuthService.getCurrentUser();
        const whatRole = AuthService.getUserRole();
        return (
            <div>
            { !loggedInUser || (whatRole === ('USER')) ? 
            <div>
              <Login></Login>
            </div> :
            <div className="top-level-page-main family-members">
                <div className="container-view-contents family-members">
                    <div className="list-wrap-contents family-members">
                        <div className="top-actions family-members">
              
                            {/* <MemberLinkBtn to='/family-members/create'> اضافة عائلة جديد  </MemberLinkBtn> */}
                            <MemberLinkBtn to='/adminboard/'> Back to Admin Board </MemberLinkBtn>
                            {/* <MemberLinkBtn to='/family-members/familystats'>  احصائيات   </MemberLinkBtn> */}
                            
                            <input
                             type="text" 
                              name="searchfield" 
                              placeholder="ابحث "
                              value={this.state.search}
                              onChange={this.onchangeFind}
                            />
                            <MdSearch size={40} color="#538D22" />
                        </div>
                        <div className="list-of-contents">
                            {this.state.members.filter(this.filterFunction).map(member => (
                                <div className="one-of-list" key={member.id}>

                                    <h4 
                                        onMouseOver={({ target }) => target.style.color = 'red'}
                                        onMouseOut={({ target }) => target.style.color = '#538D22'}
                                        onClick={() => this.showMember(member)}
                                    >{member.name}  {member.fatherName}  بشارات </h4>

  
                                </div>

                            ))}
                        </div>

                        {this.state.showMemberClicked ?      
                        <div className="set-of-icons">
                            <div className="one-action"
                                onMouseOver={({ target }) => target.style.color = 'red'}
                                onMouseOut={({ target }) => target.style.color = '#538D22'}
                            >
                                <MdDelete
                                    onClick={() => { if (window.confirm('Are you sure you want to delete this member?')) this.deleteMemberClicked(this.state.selectedMember.id) }} size={20} color="#538D22" />
                                <p >حذف</p>
                            </div>

                            <div className="one-action"
                                onMouseOver={({ target }) => target.style.color = 'red'}
                                onMouseOut={({ target }) => target.style.color = '#538D22'}
                                onClick={() => this.gotoMemberEdit(this.state.selectedMember.id)}
                            >
                                <MdBuild size={20} color="#538D22" />
                                <p>تعديل</p>
                            </div>

                            <div className="one-action"
                                onMouseOver={({ target }) => target.style.color = 'red'}
                                onMouseOut={({ target }) => target.style.color = '#538D22'}
                                onClick={() => this.gotoMemberProfile(this.state.selectedMember.id)}
                            >
                                <MdZoomIn size={20} color="#538D22" />
                                <p>ملف كامل</p>
                            </div>
                            <div className="one-action"
                                onMouseOver={({ target }) => target.style.color = 'red'}
                                onMouseOut={({ target }) => target.style.color = '#538D22'}
                                onClick={() => this.gotoUpalodProfilePicture(this.state.selectedMember.id)}
                            >
                                <MdPerson size={20} color="#538D22" />
                                <p>صوره بروفايل </p>
                            </div>

                            {this.state.selectedMemberHasChildren  ?
                                <>
                                    <div className="one-action"
                                        onMouseOver={({ target }) => target.style.color = 'red'}
                                        onMouseOut={({ target }) => target.style.color = '#538D22'}
                                        onClick={() => this.gotoChildrenList(this.state.selectedMember.id)}

                                    >
                                        <MdChildCare size={20} color="#538D22" />
                                        <p>الاطفال</p>
                                    </div>
                
                                </> : <div className="one-action"
                                    onMouseOver={({ target }) => target.style.color = 'red'}
                                    onMouseOut={({ target }) => target.style.color = '#538D22'}
                                    onClick={() => this.goToCreateChild(this.state.selectedMember.id)}
                                >
                                    <MdGroup size={20} color="#538D22" />
                                    <p>اضافة طفل </p>
                                </div>
                            }

                        </div> : <div className="set-of-icons"><h4> اختار من القائمة </h4></div> }
                    </div>

                    {this.state.showMemberClicked ?
                        <div className="details">

                            <div className="card-details">

                                <div className="card-group-field">

                                    <h5> ID </h5>
                                    <h4> {this.state.selectedMember.id}</h4>
                                </div>

                                <div className="card-group-field">
                                <h5>  {translate("name")}   </h5>
                                    <h4> {this.state.selectedMember.name}   </h4>
                                </div>

                                <div className="card-group-field">
                                <h5>    {translate("father-name")}   </h5>
                                    <h4> {this.state.selectedMember.fatherName ? this.state.selectedMember.fatherName : <h4>{translate("notfound")}</h4>}   </h4>
                                </div>

                                <div className="card-group-field">
                                <h5>   {translate("mother-name")}    </h5>
                                    <h4> {(this.state.selectedMember.motherName) ? this.state.selectedMember.motherName : <h4>{translate("notfound")}</h4>}   </h4>
                                </div>

                                <div className="card-group-field">
                                <h5> {translate("phone-num")} </h5>
                                    <h4> {this.state.selectedMember.phoneNumber ? this.state.selectedMember.phoneNumber : <h4>{translate("notfound")}</h4>}   </h4>
                                </div>
                                <div className="card-group-field">
                                <h5>   {translate("address")} </h5>
                                    <h4> {this.state.selectedMember.address ? this.state.selectedMember.address : <h4>{translate("notfound")}</h4>}   </h4>
                                </div>
                                <div className="card-group-field">
                                <h5> {translate("identity")} </h5>
                                    <h4> {this.state.selectedMember.identity ? this.state.selectedMember.identity :  <h4>{translate("notfound")}</h4>}   </h4>
                                </div>
                                <div className="card-group-field">
                                <h5>  {translate("birthdate")} </h5>
                                    <h4> {(this.state.selectedMember.birthdate) ? this.state.selectedMember.birthdate : <h4>{translate("notfound")}</h4>}   </h4>
                                </div>
                                <div className="card-group-field">
                                <h5>  {translate("gender")}  </h5>
                                    <h4> {this.state.selectedMember.gender === 'male' ? "ذكر" : "انثى" }   </h4>
                                </div>
                                <div className="card-group-field">
                                <h5> {translate("status-fam")}   </h5>
                                    <h4> {(this.state.selectedMember.isMarried === 'yes') ? "متزوج" : "اعزب"}   </h4>
                                </div>
                                <div className="card-group-field">
                                <h5> {translate("alive")}  </h5>
                                    <h4> {this.state.selectedMember.isAlive ? this.state.selectedMember.isAlive : <h4>{translate("notfound")}</h4>}   </h4>
                                </div>

                            </div>
                        </div> : <div></div>}
                </div>
            </div>
    }</div>
        )
        
    }
}
